import * as React from "react";
import C from "classnames";
const variantMapper = {
    primary: "alert-primary",
    secondary: "alert-secondary",
    success: "alert-success",
    info: "alert-info",
    warning: "alert-warning",
    danger: "alert-danger",
    light: "alert-light",
    dark: "alert-dark",
    white: "alert-white",
};
export const Alert = ({ variant = "info", children, onClick, className, dismissable, testId, }) => {
    return !dismissable ? (React.createElement("div", { className: C("alert", className && className, variant && variantMapper[variant]), "data-testid": testId }, children)) : (React.createElement("div", { className: C("alert alert-dismissable", className && className, variant && variantMapper[variant]), "data-testid": testId },
        children,
        React.createElement("button", { type: "button", className: C("close", "ml-3"), "aria-label": "Close", onClick: onClick },
            React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))));
};
//# sourceMappingURL=Alert.js.map